import React from 'react';
import { Github, Linkedin, Mail, ArrowUp, Heart } from 'lucide-react';
import { personalInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="border-t border-stone-400/30 dark:border-stone-500/25 bg-white/[0.18] dark:bg-stone-950/35 pt-16 px-6 pb-10">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          <div>
            <h3 className="text-2xl font-bold text-stone-900 dark:text-stone-100 mb-4">
              Ankit Attri
            </h3>
            <p className="text-stone-600 dark:text-stone-400 mb-6">{personalInfo.title}</p>
            <div className="flex space-x-4">
              <a
                href={personalInfo.profiles.github}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2.5 rounded-lg bg-stone-200 dark:bg-stone-800 hover:bg-amber-100 dark:hover:bg-amber-900/30 transition-colors"
                aria-label="GitHub"
              >
                <Github className="w-5 h-5 text-stone-700 dark:text-stone-300" />
              </a>
              <a
                href={personalInfo.profiles.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2.5 rounded-lg bg-stone-200 dark:bg-stone-800 hover:bg-amber-100 dark:hover:bg-amber-900/30 transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5 text-stone-700 dark:text-stone-300" />
              </a>
              <a
                href={`mailto:${personalInfo.email}`}
                className="p-2.5 rounded-lg bg-stone-200 dark:bg-stone-800 hover:bg-amber-100 dark:hover:bg-amber-900/30 transition-colors"
                aria-label="Email"
              >
                <Mail className="w-5 h-5 text-stone-700 dark:text-stone-300" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold text-stone-900 dark:text-stone-100 mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2 text-sm">
              {[
                ['About me', '#about'],
                ['Skills', '#skills'],
                ['Experience', '#experience'],
                ['Projects', '#projects'],
                ['Live signal', '#live-signal'],
                ['Demo', '#demo'],
                ['Contact', '#contact'],
              ].map(([label, href]) => (
                <li key={href}>
                  <a
                    href={href}
                    className="text-stone-600 dark:text-stone-400 hover:text-amber-800 dark:hover:text-amber-600 transition-colors"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold text-stone-900 dark:text-stone-100 mb-4">
              Coding Profiles
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  href={personalInfo.profiles.leetcode}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-stone-600 dark:text-stone-400 hover:text-amber-800 dark:hover:text-amber-600 transition-colors"
                >
                  LeetCode
                </a>
              </li>
              <li>
                <a
                  href={personalInfo.profiles.hackerrank}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-stone-600 dark:text-stone-400 hover:text-amber-800 dark:hover:text-amber-600 transition-colors"
                >
                  HackerRank
                </a>
              </li>
              <li>
                <a
                  href={personalInfo.profiles.gfg}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-stone-600 dark:text-stone-400 hover:text-amber-800 dark:hover:text-amber-600 transition-colors"
                >
                  GeeksforGeeks
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-stone-200 dark:border-stone-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-stone-600 dark:text-stone-400 text-sm flex items-center gap-2">
              Made with <Heart className="w-4 h-4 text-red-500 fill-red-500" /> by Ankit Attri
            </p>
            <p className="text-stone-600 dark:text-stone-400 text-sm">
              © {currentYear} Ankit Attri. All rights reserved.
            </p>
            <button
              onClick={scrollToTop}
              className="flex items-center space-x-2 text-sm text-amber-800 dark:text-amber-600 hover:text-amber-900 dark:hover:text-amber-500 font-medium transition-colors"
            >
              <span>Back to Top</span>
              <ArrowUp className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
